module.exports = __webpack_public_path__ + "static/media/binggrae-melon.1a03f94a.jpg";